import React from 'react';
import { Redirect, useParams } from 'react-router';
import {
  BillingPlanOption,
  UpgradeRoutingParams,
  UserBillingType,
} from 'globals/types';
import Routes from 'routes';
import { useBillingType } from 'globals/hooks/useBillingType';
import FsCenterBoxLayout from 'ui-elements/layouts/FsCenterBoxLayout/FsCenterBoxLayout';
import { revertSlugify } from 'globals/utils';
import PayAsYouGrow from './PayAsYouGrow';
import Enterprise from './Enterprise';

const Upgrade: React.FC = () => {
  const { plan: slugPlan } = useParams<UpgradeRoutingParams>();
  const plan = revertSlugify(slugPlan);
  const isBillingTypeStandard = useBillingType(UserBillingType.STANDARD);
  const isBillingTypeEnterprise = useBillingType(UserBillingType.ENTERPRISE);
  const isPlanPayAsYouGrow = plan === BillingPlanOption.PAY_AS_YOU_GROW;
  const isPlanEnterprise = plan === BillingPlanOption.ENTERPRISE;

  const getOptionToDisplay = () => {
    switch (true) {
      case isBillingTypeEnterprise:
        return <PayAsYouGrow />;
      case isBillingTypeStandard && isPlanPayAsYouGrow:
        return <PayAsYouGrow />;
      case isBillingTypeStandard && isPlanEnterprise:
        return <Enterprise />;
      default:
        return <Redirect to={Routes.ROOT} />;
    }
  };

  return (
    <FsCenterBoxLayout
      withContentCentering={false}
      isWhiteBackground={false}
      withLogin={false}
      withBackToPanel
      withAvatarMenu
    >
      {getOptionToDisplay()}
    </FsCenterBoxLayout>
  );
};

export default Upgrade;
